export const teamWorkflow = {
  junior: {
    processes: [
      { name: 'Daily Standup', description: 'Share product updates, blockers, and priorities with development teams', time: '9:00 AM daily' },
      { name: 'Sprint Planning', description: 'Lead sprint planning sessions and backlog refinement', requirement: 'Define user stories with clear acceptance criteria' },
      { name: 'Stakeholder Reviews', description: 'Regular product reviews with stakeholders', coverage: 'Weekly progress updates and demos' }
    ],
    responsibilities: [
      { area: 'Product Backlog', tasks: ['Maintain product backlog', 'Write user stories', 'Define acceptance criteria', 'Prioritize features'] },
      { area: 'Stakeholder Management', tasks: ['Gather requirements', 'Communicate product updates', 'Manage expectations', 'Collect feedback'] },
      { area: 'Team Collaboration', tasks: ['Work with engineering teams', 'Collaborate with designers', 'Coordinate with QA', 'Support marketing'] }
    ],
    ceremonies: [
      { name: 'Sprint Planning', frequency: 'Bi-weekly', duration: '2 hours', role: 'Lead planning sessions' },
      { name: 'Sprint Review', frequency: 'Bi-weekly', duration: '1 hour', role: 'Present product increments' },
      { name: 'Stakeholder Updates', frequency: 'Weekly', duration: '30 minutes', role: 'Share progress and gather feedback' }
    ]
  },
  mid: {
    processes: [
      { name: 'Product Strategy Planning', description: 'Develop and refine product strategy and roadmap', frequency: 'Monthly' },
      { name: 'Market Research', description: 'Conduct competitive analysis and market research', responsibility: 'Market intelligence and positioning' },
      { name: 'Cross-functional Leadership', description: 'Lead cross-functional initiatives and projects', scope: 'Engineering, design, marketing coordination' }
    ],
    responsibilities: [
      { area: 'Product Strategy', tasks: ['Develop product roadmap', 'Define product vision', 'Conduct market analysis', 'Set product goals'] },
      { area: 'Feature Management', tasks: ['Prioritize feature development', 'Manage feature lifecycle', 'Analyze feature performance', 'Optimize user experience'] },
      { area: 'Team Leadership', tasks: ['Mentor junior PMs', 'Lead product discussions', 'Drive decision making', 'Facilitate collaboration'] }
    ],
    ceremonies: [
      { name: 'Product Strategy Review', frequency: 'Monthly', duration: '3 hours', role: 'Lead strategy sessions' },
      { name: 'Roadmap Planning', frequency: 'Quarterly', duration: '4 hours', role: 'Define product roadmap' },
      { name: 'Performance Review', frequency: 'Monthly', duration: '2 hours', role: 'Analyze product metrics' }
    ]
  },
  senior: {
    processes: [
      { name: 'Product Vision and Strategy', description: 'Define long-term product vision and strategic direction', scope: 'Company-wide product strategy' },
      { name: 'Portfolio Management', description: 'Manage product portfolio and resource allocation', responsibility: 'Product investment decisions' },
      { name: 'Executive Communication', description: 'Regular communication with executive team on product performance', impact: 'Strategic business decisions' }
    ],
    responsibilities: [
      { area: 'Strategic Leadership', tasks: ['Define product vision', 'Set strategic direction', 'Drive innovation', 'Lead product organization'] },
      { area: 'Business Impact', tasks: ['Drive revenue growth', 'Optimize business metrics', 'Manage P&L', 'Strategic partnerships'] },
      { area: 'Organization Development', tasks: ['Build product teams', 'Develop product culture', 'Mentor product leaders', 'Drive best practices'] }
    ],
    ceremonies: [
      { name: 'Executive Product Review', frequency: 'Monthly', duration: '2 hours', role: 'Present to executive team' },
      { name: 'Strategic Planning', frequency: 'Quarterly', duration: '8 hours', role: 'Lead strategic planning sessions' },
      { name: 'Board Reporting', frequency: 'Quarterly', duration: '3 hours', role: 'Product performance reporting' }
    ]
  }
};
